import { Injectable } from '@angular/core';
import { FeatureService, ZITI_URLS } from '@netfoundry-ui/shared/services';
import { TabInterceptorService } from 'ziti-console-lib';

/**
 * Points every list-page tab strip (ziti-console-lib's header) at the redesigned beta
 * lists when the beta toggle is on, and adds a beta-gated "Templates" tab to Services.
 */
@Injectable({ providedIn: 'root' })
export class ServiceTemplatesTabInterceptorService implements TabInterceptorService {
    constructor(private featureService: FeatureService) {}

    override(key: string, tabs: any[]): any[] {
        if (!Array.isArray(tabs)) {
            return tabs;
        }
        const featureService = this.featureService;
        // A getter keeps the url reactive: betaFeaturesEnabled loads async with user preferences.
        // betaListRoute passes through any url with no beta list route, so non-beta tabs are unchanged.
        const mapped = tabs.map((tab) => ({
            ...tab,
            get url() {
                return featureService.betaListRoute(tab.url);
            },
        }));
        if (key !== 'services') {
            return mapped;
        }
        return [
            ...mapped,
            {
                label: 'Templates',
                get url() {
                    return featureService.betaListRoute(ZITI_URLS.ZITI_SERVICE_TEMPLATES);
                },
                // getTabs() runs once at page init, but betaFeaturesEnabled loads async with
                // user preferences. A getter keeps the lib's [hidden]="tab.hidden" binding
                // reactive so the tab appears once the preference resolves, not only after a
                // re-navigation.
                get hidden() {
                    return !featureService.betaFeaturesEnabled;
                },
            },
        ];
    }
}
